














































import ModpackService from "@/classes/ModpackService";
import Vue from "vue";
import Component from "vue-class-component";

@Component({})
export default class ModpackUploadDialog extends Vue {
  public uploading: boolean = false;
  public dialog: boolean = false;

  public newModpack: File | null = null;

  public async triggerUpload(modpack: File | null) {
    if (modpack === null) {
      return;
    }
    this.uploading = true;
    const newModpack = await ModpackService.uploadModpack(modpack);
    this.uploading = false;
    this.$emit("update-modpack", newModpack.id);
    this.dialog = !this.dialog;
  }
}
